<div class="w-full p-gutter text-center">
    <img class="w-full max-w-lg mx-auto mb-6" src="assets/img/illustrations/data_center.svg" />
    <h1 class="display-3 font-medium m-0">401</h1>
    <h2 class="title m-0 mt-3 max-w-lg mx-auto">Unauthorized.</h2>
    <div
      class="bg-foreground rounded-full overflow-hidden relative ltr:pl-5 rtl:pr-5 h-12 max-w-md w-full shadow-xl mx-auto mt-6 flex items-center">
      <!-- <button (click)="backToDashboard()"
        class="border-0 h-12 outline-none rtl:pr-4 placeholder:text-secondary bg-foreground flex-auto">
        Back to Dashboard
      </button> -->
    </div>
